export default __webpack_public_path__ + "static/media/blinderLogo.8cd7d8ee.svg";